// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.empty-data-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--surface-primary);
  border-radius: 4px;
  padding: 30px 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.empty-data-spinner {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;

  svg {
    rect:nth-child(1) {
      fill: var(--illustration-tertiary3);
    }
    rect:nth-child(2) {
      fill: var(--illustration-tertiary2);
    }
    rect:nth-child(3) {
      fill: var(--illustration-tertiary1);
    }
  }
}

.empty-data-text {
  margin-top: 12px;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 700;
  font-style: Bold;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: -0.4px;
  text-align: center;
  vertical-align: middle;
  color: var(--text-primary);
}
`, "",{"version":3,"sources":["webpack://./src/Components/ErrorMessage/ErrorMessage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;;EAElB;IACE;MACE,mCAAmC;IACrC;IACA;MACE,mCAAmC;IACrC;IACA;MACE,mCAAmC;IACrC;EACF;AACF;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;AAC5B","sourcesContent":[".empty-data-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--surface-primary);\n  border-radius: 4px;\n  padding: 30px 0;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n}\n\n.empty-data-spinner {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n\n  svg {\n    rect:nth-child(1) {\n      fill: var(--illustration-tertiary3);\n    }\n    rect:nth-child(2) {\n      fill: var(--illustration-tertiary2);\n    }\n    rect:nth-child(3) {\n      fill: var(--illustration-tertiary1);\n    }\n  }\n}\n\n.empty-data-text {\n  margin-top: 12px;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 700;\n  font-style: Bold;\n  font-size: 20px;\n  line-height: 24px;\n  letter-spacing: -0.4px;\n  text-align: center;\n  vertical-align: middle;\n  color: var(--text-primary);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
